import { HashAnchor } from 'components/HashAnchor';
import FormGroup from 'components/shared/FormGroup';
import InputText from 'components/shared/InputText';
import { Controller, useFormContext } from 'react-hook-form';
import { FormTextProps } from './FormText.types';

export const FormText: React.FC<FormTextProps> = ({
  name,
  formGroup = {},
  input = {}
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const onChangeHandler =
    input.onChange ||
    (() => {
      // NOOP
    });

  return (
    <FormGroup
      {...formGroup}
      error={errors?.[name]?.message?.toString()}
      forId={name}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <HashAnchor name={`anchor_${name}`} />
            <InputText
              id={name}
              aria-label={name}
              type="text"
              variant={errors?.[name] ? 'error' : ''}
              {...input}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                onChangeHandler(e);
              }}
            />
          </>
        )}
      />
    </FormGroup>
  );
};
